import {DividendPayoutChartDataPoint} from "../types/DividendPayoutChartData";

export default function() {
    return {
        chart: {
            type: "multiBarChart",
            height: 340,
            margin: {
                top: 10,
                right: 30,
                bottom: 50,
                left: 60
            },
            x: (d: DividendPayoutChartDataPoint) => d[0],
            y: (d: DividendPayoutChartDataPoint) => d[1],
            showControls: false,
            showValues: true,
            duration: 1000,
            stacked: true,
            useInteractiveGuideline: true,
            xAxis: {
                showMaxMin: false,
                highlightZero: false
            },
            yAxis: {
                tickFormat: (v: number) => d3.format("$,.3f")(v)
            }
        }
    };
}
